export const namespace = 'customsDocuments';
